// import { cva } from 'cva'
export const inputContainerlassNames = [
    '@flex',
    '@items-center',
    '@relative',
    '@space-x-1.5',
    '@px-2',
    '@py-1.5',
    '@rounded',
    '@border',
    '@border-grey-2_5',
    '@bg-grey-2-a',
    'data-[state=error]:@border-red1-1',
    'data-[state=focus]:@border-brand1-1',
    'data-[state=disabled]:@bg-grey-2',
];
export const inputClassNames = [
    '@text-b2',
    '@text-grey-6',
    '@flex-1',
    '@min-w-0',
    '@outline-none',
    '@bg-transparent',
    'data-[state=disabled]:@cursor-not-allowed',
    'data-[state=disabled]:@text-grey-4',
];
export const inputErrorContainerClassNames = [
    '@mt-0.5',
];
export const inputErrorClassNames = [
    '@text-red1-1',
    '@text-caption',
    '@flex',
    '@items-center',
    '@space-x-0.5',
];
export const inputErrorIconClassNames = [
    '@w-3.5',
    '@h-3.5',
    '@mr-0.5',
];
export const inputPasswordIconClassNames = [
    '@cursor-pointer',
];
